import { ChangeEvent, useState } from "react";
import axiosInstance from "../api/apiClient";

const UploadBook = ({ bookId }: { bookId: string | undefined }) => {
    const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      if (selectedFile.type === "application/epub+zip") {
        setFile(selectedFile);
      } else {
        alert("Alleen EPUB-bestanden zijn toegestaan.");
      }
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    const input = document.getElementById("dropzone-file") as HTMLInputElement;
    if (input) input.value = "";
  };

const handleSubmit = async () => {
  if (!file) return;

//   const bookId = "123"; // Vervang dit met een echte waarde in je app

  const reader = new FileReader();

  reader.onloadend = async () => {
    const base64 = reader.result as string;

    try {
      const response: any = await axiosInstance.post(`/uploadEpub/${bookId}`, { epubBase64: base64 });

      alert("Upload gelukt!");
    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload mislukt.");
    }
  };

  reader.readAsDataURL(file);
};


  return (
    <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
      <h1 className="text-2xl font-bold mb-1 text-[#60637A]">Upload EPUB</h1>

      {!file &&

       <div className="flex items-center justify-center w-full">
        <label
          htmlFor="dropzone-file"
          className={`flex flex-col items-center justify-center w-full h-64 border-2 border-dashed rounded-lg cursor-pointer ${
            file ? "border-green-400 bg-green-50" : "border-gray-300 bg-gray-50"
          }`}
        >
          <div className="flex flex-col items-center justify-center pt-5 pb-6">
            <svg
              className="w-8 h-8 mb-4 text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 16"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
              />
            </svg>
            <p className="mb-2 text-sm text-gray-500">
              <span className="font-semibold">Click to upload</span> or drag and drop the file here
            </p>
            <p className="text-xs text-gray-500">EPUB (max 10MB)</p>
          </div>
          <input
            id="dropzone-file"
            type="file"
            className="hidden"
            accept=".epub"
            onChange={handleFileChange}
          />
        </label>
      </div>

      }

      {file && (
        <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="bg-gray-100 text-gray-800 px-4 py-2 rounded-xl text-sm flex items-center justify-between w-full sm:w-auto">
            📘 {file.name}
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleRemoveFile}
              className="bg-red-100 text-red-600 hover:bg-red-200 rounded-xl px-4 py-2 text-sm font-medium"
            >
              Remove File
            </button>
            <button
              onClick={handleSubmit}
              className="bg-blue-600 text-white hover:bg-blue-700 rounded-xl px-4 py-2 text-sm font-medium"
            >
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );

}

export default UploadBook